import React from 'react';

const Quinto = () => { 
    return (
        <div className='seccion'>
		
            <h1>PROGRAMAS DE ESTUDIOS - 2025</h1>

            <h4>Materias Plan Institucional - 5to año</h4>

            <div className="contenedor-tablas">
		    <table className="tabla-programas">
			<caption>5to Año - Ecologico - Plan 128</caption>
			<tr>

				<th>Materia</th>
				<th>Programa</th>

			</tr>
			
			<tr>

				<td>Matematica</td>
				<td><a href="https://drive.google.com/drive/folders/1Wn3miFRxXv8HkNbGDsDczliIdkyUJy7n?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Lengua y Literatura</td>
				<td><a href="https://drive.google.com/drive/folders/1P62s9JMTK6AvTpfgF2e018CR0BsT8lve?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Historia</td>
				<td><a href="https://drive.google.com/drive/folders/1kVswf8fZCAXVQ0Z7hlfkWnYcK8GrZktZ?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Geografia</td>
				<td><a href="https://drive.google.com/drive/folders/1aHJSmg4n398v012ktmM94Y5hlzY0q6v1?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Ecologia II</td>
				<td><a href="https://drive.google.com/drive/folders/1EbmBE5c_GUrnvFRXCAy6g3lcHwvEU7Xz?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Taller y Practica de Campo</td>
				<td><a href="https://drive.google.com/drive/folders/16VqWsHD02oy3ZNoPTy54YgJ4mp727tJt?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Educacion para la Salud</td>
				<td><a href="https://drive.google.com/drive/folders/1bSyKOMciCVDWdXnVHN9NEHWYKXQkAcVV?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Introduccion a la Informatica</td>
				<td><a href="https://drive.google.com/drive/folders/1XyiL3xbqz-DPz1xj2LIKfEHyG9fMtdN1?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Ingles Tecnico</td>
				<td><a href="https://drive.google.com/drive/folders/1qCb2sJhG8dKvjwvW0fOv-sqTM5m6hGnS?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Quimica Organica</td>
				<td><a href="https://drive.google.com/drive/folders/1yLoqsQTHjKQNTSNmpwlHsO49AgNNYCY7?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Bioestadistica</td>
				<td><a href="https://drive.google.com/drive/folders/1tZdjuVKtGHJpqjqZ58krkbi1wF2_mP0t?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			
			<tr>

				<td>Filosofia</td>
				<td><a href="https://drive.google.com/drive/folders/1MDVV31wCAKjOxYh4Myc2KZ2GvhO3uRf2?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Educacion Fisica</td>
				<td><a href="https://drive.google.com/drive/folders/1IAzVnx918x_VVcPbiNT78O5HLys2k2T9?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
		</table>
		
		<table className="tabla-programas">
			<caption>5to Año - Humanistico - Plan 182</caption>
			<tr>

				<th>Materia</th>
				<th>Programa</th>

			</tr>
			<tr>

				<td>Literatura</td>
				<td><a href="https://drive.google.com/drive/folders/1ly6rDNjFcKmpXLOuKCGbLiaaY1QQIgWS?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Ingles</td>
				<td><a href="https://drive.google.com/drive/folders/12YOJkrH8f3j22sfRmA7JvRvYwyS156W9?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Edicacion Fisica</td>
				<td><a href="https://drive.google.com/drive/folders/1kOnNZixY0Ueoy7hPyzHJ2q0AwXPTRtQv?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Matematica</td>
				<td><a href="https://drive.google.com/drive/folders/18Si3QnX3q_0IfSBYcCR_8n0e4exDTeXI?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Fisica</td>
				<td><a href="https://drive.google.com/drive/folders/1oHOC3ya_dEuptnZ0uCTl34-QAoZDp5pC?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Quimica</td>
				<td><a href="https://drive.google.com/drive/folders/1P6vHTzj5jMJAMeM68Rxkc2kk3nZRyw6n?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Medios de Comunicacion</td>
				<td><a href="https://drive.google.com/drive/folders/16puZAOxvat5cQ7YonpUulxRShJjeNyWb?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Ciencias Biologicas</td>
				<td><a href="https://drive.google.com/drive/folders/1GyQSOoovBsWmlxBfmk1ljhrMTZ-mMm7r?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td style={{ fontSize: '13px' }}>Metodologia de la Investigacion Aplicada</td>
				<td><a href="https://drive.google.com/drive/folders/15vDWj1onBR6N_FJMpvJY4N3zinpVvbKM?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Ciencias Sociales</td>
				<td><a href="https://drive.google.com/drive/folders/1yBcf36ieJBFfZYiB1n1ZWSpaXObsPSza?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Psicologia</td>
				<td><a href="https://drive.google.com/drive/folders/1GWDXof0gnleHEIji5M6xRGT2R_aM_Cou?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Taller Integrador I</td>
				<td><a href="https://drive.google.com/drive/folders/15k6_DNYMalSZh9rCAG4E4plL4QW8Lfpx?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Informatica V</td>
				<td><a href="https://drive.google.com/drive/folders/1NA6B54K5d_N7ffLjMEobT4hf3cvo_o3d?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

			</tr>

		</table>

	</div>
        </div>
    );
}

export default Quinto;
